import React from "react";
import SharedWorkOrder from "../../shared/work-order";
import { ProfileBodyProps } from "../../types";

const WorkOrder = React.memo((props: ProfileBodyProps) => {
  if (!props.campaignId) return <></>;
  const user = props.user;
  return (
    <SharedWorkOrder
      userId={user.id}
      brandId={props.brandId}
      campaignId={props.campaignId}
    />
  );
});

WorkOrder.displayName = "WorkOrder";

export default WorkOrder;
